import moment from "moment";

const PeriodScholarship = {

  statementPeriod() {
    const [month, day] = this.period();
    const firstPeriod = (month === 2 && day >= 1) && (month === 2 && day <= 10);
    const secondPeriod = (month === 7 && day >= 1) && (month === 7 && day <= 10);

    return firstPeriod || secondPeriod;
  },

  fullPeriod() {
    const [month, day] = this.period();
    const firstPeriod = (month === 2 &&day >= 1) && (month === 2 && day <= 15);
    const secondPeriod = (month === 7 && day >= 1) && (month === 7 && day <= 15);

    return firstPeriod || secondPeriod;
  },

  period() {
    const date = new Date();
    return [date.getMonth() + 1, date.getUTCDate()]
  }

}

export default PeriodScholarship